class Controller {
  constructor($mdDialog, latLng, title, GoogleMaps) {
    "ngInject";

    this.map = {};
    this.zoom = 15;
    this.title = title;
    this.$mdDialog = $mdDialog;
    this.latLng = [latLng[1], latLng[0]];
    this.center =
      this.latLng &&
      this.latLng.length &&
      `${this.latLng[0]},${this.latLng[1]}`;

    this.googleMapsUrl = GoogleMaps.getSource();

    this.triggerMapsResizeEvent = (map) =>
      window.google.maps.event.trigger(map, "resize");

    this.onMapInit = (map) => {
      this.map = map;
      this.triggerMapsResizeEvent(map);
    };
  }

  close() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/mapPoint/locationDialog/locationDialog.controller.js